import { isProjectPreview } from 'owa-timestream-store';
import { useProjectId } from './useProjectId';

export default function useIsProjectPreview() {
    const projectId = useProjectId();
    return !!projectId ? isProjectPreview(projectId) : true;
}
